import { AxiosError } from "axios";
import { ErrorWithMessage } from "../models";

export const toAxiosErrorMessage = (error: AxiosError<{ Error: unknown }, unknown>): ErrorWithMessage => {
    let message = error.message;
    if (error.response?.data?.Error) {
        message = error.response.data.Error as string;
    }
    return { message };
};
